import { Loader2 } from "lucide-react";

export const LeadTable = ({ kind, columns, items, loading, onReview, onDelete }) => (
  <div className="relative overflow-x-auto border border-white/10">
    <table data-testid={`admin-table-${kind}`} className="w-full min-w-[1100px] text-left text-sm">
      <thead className="bg-[#1E293B] font-mono text-[11px] uppercase tracking-[0.12em] text-slate-400">
        <tr><th className="px-4 py-3 font-medium">Action</th>{columns.map((c) => <th key={c.key} className="px-4 py-3 font-medium">{c.label}</th>)}</tr>
      </thead>
      <tbody className="divide-y divide-white/5 text-slate-300">
        {items.map((r) => (
          <tr key={r.id} data-testid={`admin-row-${r.reference}`} className="transition-colors hover:bg-white/[0.03]">
            <td className="px-4 py-3 align-top">
              <button onClick={() => onReview(r)} data-testid={`admin-review-${r.reference}`}
                className="whitespace-nowrap border border-orange-500/60 px-3 py-1 text-xs font-semibold text-orange-300 hover:bg-orange-500 hover:text-white">Review KYC</button>
              {onDelete && (
                <button onClick={() => onDelete(r)} data-testid={`admin-delete-${r.reference}`}
                  className="mt-2 block whitespace-nowrap border border-red-500/50 px-3 py-1 text-xs font-semibold text-red-300 hover:bg-red-600 hover:text-white">Remove</button>
              )}
            </td>
            {columns.map((c) => <td key={c.key} className="px-4 py-3 align-top">{c.render ? c.render(r) : r[c.key]}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
    {!loading && items.length === 0 && (
      <p data-testid="admin-table-empty" className="px-4 py-12 text-center text-slate-500">No sign-ups match these filters.</p>
    )}
    {loading && (
      <div className="absolute inset-0 flex items-center justify-center bg-[#0B1120]/60"><Loader2 className="h-6 w-6 animate-spin text-orange-500" /></div>
    )}
  </div>
);
